import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { BaseSiteService, CmsService, OccEndpointsService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { SharedService } from 'src/app/shared/services/shared.service';
import { OpenStatementsService } from '../open-statements.service';
import { StatementDisplayComponent } from '../statement-display/statement-display.component';

const statementCssClass = 'col-xs-12 order-1 col-sm-12 order-sm-1 col-md-12 order-md-2 col-lg-12 order-lg-2';
const accountOverviewCssClass = 'col-sm-12';
const dateFormat = 'yyyy-MM-dd';

@Component({
  selector: 'app-open-statements',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './open-statements.component.html',
  styleUrls: ['./open-statements.component.scss'],
})
export class OpenStatementsComponent implements OnInit, OnDestroy {
  @Input() hideAside: boolean;
  showSection = false;
  recordLength = 10;
  statementWidth: string = statementCssClass;
  statementsData: any;
  @Input() restrictToTen?= false;
  showPortal = false;
  details: any;
  showModal = false;
  accountId = null;
  userAcccountSub: Subscription;
  statementSub: Subscription;
  reloadSub: Subscription;
  isComServeAgent: boolean = false;
  isAsmUser: boolean = false;
  csAgentAuthSubscription: Subscription;
  firewallExempt: boolean = false;

  constructor(
    private readonly stService: OpenStatementsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly datePipe: DatePipe,
    private readonly modalService: NgbModal,
    private readonly cmsService: CmsService,
    private readonly occService: OccEndpointsService,
    private baseSiteService: BaseSiteService,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly sharedService: SharedService
  ) { }
  public windowReference = null;
  bannerURL: string;

  baseSiteId: string;

  ngOnInit(): void {
    if (!!this.hideAside) {
      this.statementWidth = accountOverviewCssClass;
      this.showSection = this.hideAside;
    } else {
      this.statementWidth = statementCssClass;
      this.showSection = false;
    }
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
    // this.firewallExempt = this.sharedService.getSessionStorage('firewallExempt');
    this.stService.getAccountId().pipe(take(1)).subscribe(res => {
      this.accountId = res.defaultB2BUnit.uid;
      this.statementSub = this.stService
        .getStatements({
          accountId: this.accountId,
          fields: 'DEFAULT',
        })
        .subscribe((res) => {
          if (res) {
            if (res.isComServeAgent) {
              this.recordLength = 0;
              this.isComServeAgent = res.isComServeAgent;
            }
            else {
              if (this.restrictToTen) {
                this.recordLength = 10;
              }
              else {
                this.recordLength = res.dateMap.length;
              }
            }
            this.statementsData = JSON.parse(JSON.stringify(res));
            // this.statementsData?.dateMap?.entry?.map((res) => {
            //   res.value = new Date(res?.value);
            //   res.key = new Date(res?.key);
            // });
            this.cdr.detectChanges();
          }
        });
    });



    this.reloadSub = this.stService.reloadComponent.subscribe((res) => {
      this.showPortal = false;
      this.showModal = false;
      this.cdr.detectChanges();
    });

    // this.cmsService.getComponentData('ProductGridPageVerticalBannerComponent').subscribe((res:any) => {
    //   this.bannerURL =this.occService.getBaseEndpoint({baseUrl:true,prefix:false,baseSite:false})+ res.media.url;
    //   
    // });
    this.cdr.detectChanges();
  }

  formatDate(dt){
      const splittedDate = dt?.split('-');
      // [splittedDate[0],splittedDate[1],splittedDate[2]] = [splittedDate[2],splittedDate[0],splittedDate[1]];
      return new Date(splittedDate[2], splittedDate[0], splittedDate[1]);
      // return splittedDate.join('-');
       
  }

  openNewModalPopup(endDate) {
    // fromDte: startDate,
    this.details = { toDte: this.datePipe.transform(endDate, dateFormat) };
    const modalRef = this.modalService.open(StatementDisplayComponent, {
      backdrop: 'static',
      scrollable: false,
      windowClass: `acc-statement-modal ${this.baseSiteId}`,
    });
    modalRef.componentInstance.toShow = true;
    modalRef.componentInstance.statement = this.details;
    modalRef.componentInstance.baseSiteId = this.baseSiteId;
    this.showPortal = this.showModal = true;
  }

  generateSavePdf(endDate) {
    this.showPortal = true;
    this.details = { toDte: this.datePipe.transform(endDate, dateFormat) };
    this.stService.loadStatements.next(this.details);
  }

  viewCurrent() {
    const currentDate = new Date();
    const myDate = this.datePipe.transform(currentDate, dateFormat);
    // const fromDateTimeStamp = new Date(
    //   new Date(this.statementsData?.dateMap?.entry[0]?.key).getTime() +
    //   TwentyFour * Sixty * Sixty * Thousand
    // );
    // const fromDate = this.datePipe.transform(fromDateTimeStamp, dateFormat);
    this.openNewModalPopup(myDate);
  }

  viewPDF() {
    if (!!this.statementsData) {
      const currentDate = new Date();
      const myDate = this.datePipe.transform(currentDate, dateFormat);
      // const fromDateTimeStamp = new Date(
      //   new Date(this.statementsData?.dateMap.entry[0].key).getTime() +
      //   TwentyFour * Sixty * Sixty * Thousand
      // );
      // const fromDate = this.datePipe.transform(fromDateTimeStamp, dateFormat);
      this.generateSavePdf(myDate);
    }
  }

  ngOnDestroy() {
    this.userAcccountSub?.unsubscribe();
    this.statementSub?.unsubscribe();
    this.reloadSub?.unsubscribe();
    this.csAgentAuthSubscription?.unsubscribe();
  }

  asmStringCheck(){
    // this.isComServeAgent = true;
    // this.isAsmUser = true;
    // this.firewallExempt = true;

    // if(this.isComServeAgent || (this.isAsmUser && !this.firewallExempt)){
    if(this.isComServeAgent && this.isAsmUser){
      return true;
    }
    return false;
  }
}